export const HMC_VISIBILITY_PATH = '/visibility';

export enum HMC_PAGE_PATH {
  CATEGORY_PAGE = '/category_page',
  SUBCATEGORY_PAGE = '/sub_category',
}
